import styled from "styled-components";

export const FilteredViewWrapper = styled.div`
  width : 100%;
  min-height: 100%;
  margin : 0 0 auto 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => props.isOld ? 'repeat(7, 1fr)' : 'repeat(3, 1fr)'};
  column-gap: 5px;
  row-gap: 5px;
`;

export const PaginationContainer = styled.div`
  padding: 20px 0;
`;